import { styled } from '@material-ui/core'
import { NavLink } from 'react-router-dom'

export const MenuWrapper = styled('nav')({
  margin: '8px 0',
})

export const MenuLink = styled(NavLink)({
  display: 'block',
  padding: 12,
  textDecoration: 'none',
  background: '#FFF',
  color: '#666',
  transition: 'all ease-in-out .2s',

  '&:hover': {
    background: '#EEE',
  },

  '&.active': {
    background: '#CFDEE7',
  },
})

export const MenuSubtitle = styled('h5')({
  margin: '8px 0',
  padding: '24px 12px 6px',
})

MenuLink.defaultProps = {
  activeClassName: 'active',
}
